import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Version 1.1.2", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-sm-row gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/impressum",
      target: "_blank"
    }, "Impressum")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "/datenschutz",
      target: "_blank"
    }, "Datenschutzerklärung")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CFooter = _resolveComponent("CFooter")!

  return (_openBlock(), _createBlock(_component_CFooter, { class: "d-flex align-items-center gap-3" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()) + " ENERLOGGER", 1)
      ]),
      _hoisted_3
    ]),
    _: 1
  }))
}